export default function GetVoucherUser(_domain){
  if(_domain==="https://api.e-paylink.com" || _domain==="https://api.westernunion.gr"){
    return "dmVyaWFo";
  }
  else{
    return "dmVyaWFo";
  }
}
